import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import { getReportRenderSetting } from "../store/actions/defaultAction";
import { DEFAULT_RENDER_CONFIG, normalizeRenderConfig } from "../store/renderConfig";

const useReportRenderSettingLoader = ({
  userId,
  organizationId,
  reportTypeId,
  renderConfigOptions,
  setRenderConfig,
}) => {
  const dispatch = useDispatch();
  const renderSettingKey = useMemo(
    () =>
      userId && organizationId && reportTypeId
        ? `${userId}:${organizationId}:${reportTypeId}`
        : "",
    [organizationId, reportTypeId, userId]
  );
  const [loadedRenderSettingKey, setLoadedRenderSettingKey] = useState("");

  useEffect(() => {
    if (!renderSettingKey) {
      setLoadedRenderSettingKey("");
      return;
    }

    let isActive = true;
    setLoadedRenderSettingKey("");

    dispatch(getReportRenderSetting({ userId, organizationId, reportTypeId }))
      .then((setting) => {
        if (!isActive) return;
        setRenderConfig(normalizeRenderConfig(setting?.renderConfig, renderConfigOptions));
        setLoadedRenderSettingKey(renderSettingKey);
      })
      .catch(() => {
        if (!isActive) return;
        setRenderConfig(normalizeRenderConfig(DEFAULT_RENDER_CONFIG, renderConfigOptions));
        setLoadedRenderSettingKey(renderSettingKey);
      });

    return () => {
      isActive = false;
    };
  }, [
    dispatch,
    organizationId,
    renderConfigOptions,
    renderSettingKey,
    reportTypeId,
    setRenderConfig,
    userId,
  ]);

  return Boolean(renderSettingKey) && loadedRenderSettingKey !== renderSettingKey;
};

export default useReportRenderSettingLoader;

